import React from 'react'
import { Icon, type TIconProps } from '~/components/icon'
import { useSelectContext } from '../../select'
import type { SelectIconProps, SelectScopedProps } from '../../select.types'

export function SelectIcon({
  __scopeInputSelect,
  color = 'colorTextNeutralDefault',
  ...props
}: SelectScopedProps<SelectIconProps>) {
  const { size, hasError, disabled, readOnly } = useSelectContext(
    'InputSelectField',
    __scopeInputSelect
  )

  const iconSize = React.useMemo(() => {
    const inputTextIconSizeMapper: Record<string, TIconProps['size']> = {
      md: 'small',
      ml: 'small',
      lg: 'small',
      xl: 'small',
    }
    return inputTextIconSizeMapper?.[size!]
  }, [size])

  return (
    <div className="flex h-6 h-small w-6 items-center justify-center rounded-none opacity-100">
      <Icon
        {...props}
        size={iconSize}
        color={
          hasError
            ? 'colorTextDangerAlternative'
            : disabled
              ? 'colorTextNeutralDisabled'
              : readOnly
                ? 'colorTextNeutralReadonly'
                : 'colorTextNeutralDefault'
        }
      />
    </div>
  )
}
